export default {
  authors: [],
  authorData: [],
};
